'use strict';

var processInclude = require('base/util');
var baseHelper = require('./product/base');
var slickHelper = require('./utils/slick');
var customUtil = require('./customUtil');
var sitePrefs = SitePreferences || window.SitePreferences;
var resource = Resources || window.Resources;
var Cookies = require('js-cookie');

/**
 * Removes carousel slides based on data attribute
 * @param {jQuery} $carousel - The carousel being modified
 */
function removeOldSlides($carousel) {
    var slideIndex = $carousel.attr('data-number-of-slides');
    if (!slideIndex) {
        slideIndex = $carousel.slick('getSlick').slideCount
    } else {
        slideIndex = parseInt(slideIndex);
    }
    while (slideIndex > 0) {
        $carousel.slick('slickRemove', slideIndex);
        slideIndex--;
    }
}

/**
 * Updates tile carousel with new variant images
 * @param {jQuery} $swatch - The swatch button that was clicked
 * @param {jQuery} container - The product tile container 
 */
function updateTileCarousel($swatch, container) {
    // also add disabled class to swatches
    container.find('.color-attribute').addClass('disabled');
    var images = $swatch.data('variantImages').split('|');
    var alt = $swatch.data('colorname') + '-' + $swatch.data('varname');
    var $carousel = $swatch.closest('.product').find('.plp-slider');

    for (var i = 0; i < images.length; i++) {
        var $anchorWrapper = $('<a/>').attr('href', $swatch.data('url'));
        var imageUrl = images[i];
        var isAlt = i > 0;
        var $img = $('<img/>').attr({
            'class': 'tile-image lazy-image image-loaded' + (isAlt ? ' tile-image--alt' : ''),
            'src': imageUrl,
            'data-src': imageUrl,
            'data-lazy': imageUrl,
            'alt': alt,
            'itemprop': 'image'
        });
        // Only empties carousel right before we add the first new slide
        if (i === 0) {
            $carousel.slick('slickAdd', $anchorWrapper.html($img), 0, true);
            // slickRemove old images
            // use $carousel.attr('data-number-of-slides') to find total number of slides
            removeOldSlides($carousel, $swatch);
            $carousel.attr('data-number-of-slides', $swatch.attr('data-number-of-slides'));
        } else {
            $carousel.slick('slickAdd', $anchorWrapper.html($img));
        }
    }

    container.find('.color-attribute').removeClass('disabled');
}

/**
 * Gets variant images and creates carousel
 * @param {jQuery} $swatch - The swatch element
 * @param {container} container - The product tile container
 */
function handleVariantImages($swatch, container) {
    var url = $swatch.data('variantImages');
    var imgfront = $swatch.data('imgfront');
    var imgfrontalt = $swatch.data('imgfrontalt');
    var imgback = $swatch.data('imgback');
    var imgbackalt = $swatch.data('imgbackalt');

    if (url && container.find('.slick-initialized').length > 0) {
        updateTileCarousel($swatch, container);
    } else {
        container.find('.front-card').attr({ src: imgfront, alt: imgfrontalt });
        container.find('.back-card').attr({ src: imgback, alt: imgbackalt });
    }
}

$(document).ready(function () {

    processInclude(require('./search/categoryMarketingSlotTile'));
    processInclude(require('./search/search'));
    processInclude(require('./product/quickView'));
    processInclude(require('./product/wishlist'));

    /**
     * triggerLoadMore
     * @return boolean
     */
    function triggerLoadMore() {
        var elem = $('.btn.btn-outline-primary.col-12.col-sm-4.button-secondary');
        if (!elem.hasClass('loading')) {
            elem.trigger('click');
            elem.hide();
        }
    }

    /**
     * Check the window position
     * @return Boolean
     */
    function isScrolledIntoView() {
        var prodDetailBottom = $('.btn.btn-outline-primary.col-12.col-sm-4.button-secondary');

        if (prodDetailBottom.length === 0) {
            return false;
        }

        return $(window).scrollTop() + $(window).height() >= prodDetailBottom.offset().top;
    }

    $(window).on('scroll', function () {
        if (isScrolledIntoView() && !Cookies.get('UsableNetAssistive')) {
            triggerLoadMore();
        }
    });
});
$('.sizeGuide-link').on('click', function () {
    $('.product-detail').addClass('sizeGuideShow');
});

$(document).on('hidden.bs.modal', '#pdp-sizeGuide', function () {
    $('.product-detail').removeClass('sizeGuideShow');
});

$(document).ready(function () {
    var backToTop = $('.back-to-top-btn');

    backToTop.hide();
    $(window).on('scroll', function () {
        if ($(this).scrollTop() > 500) {
            backToTop.fadeIn();
        } else {
            backToTop.fadeOut();
        }
    });
});

$('.sizeGuide-link').on('click', function () {
    $('.product-detail').addClass('sizeGuideShow');
});

$(document).on('hidden.bs.modal', '#pdp-sizeGuide', function () {
    $('.product-detail').removeClass('sizeGuideShow');
});

$(document).on('click', '.color-swatches button', function () {
    var $this = $(this);
    var container = $this.closest('.product-tile');
    handleVariantImages($this, container);

    container.find('button').removeClass('active');
    container.find('button.color-attribute').each(function () {
        $(this).attr('aria-checked', false);
    });
    $this.addClass('active').attr('aria-checked', true);
    var listprice = $this.data('listprice');
    var salesprice = $this.data('salesprice');
    var percentageoff = $this.data('percentageoff');
    var isNew = $this.data('isnew');
    var isBestSeller = $this.data('isbestseller');
    var exclusiveBadge = $this.data('exclusivebadge');
    var exclusiveBadgeID = $this.data('exclusivebadgeid');
    var salesBadge = $this.data('salesbadge');
    var id = $this.data('id');
    var defaultVariantId = $this.data('defaultvariantid');
    var hasSalePricebook = $this.data('hassalepricebook');
    var promotions = $this.data('promotions');
    var url = $this.data('url');
    var quickviewUrl = '/on/demandware.store/Sites-aando-Site/default/Product-ShowQuickView?pid=' + id;
    var name = $this.data('varname');
    container.find('.link').text(name);
    container.find('a').attr({ href: url });
    container.find('a.quickview').attr({ href: quickviewUrl });

    container.find('.bfx-sku').text(defaultVariantId);
    if (!listprice) {
        container.find('.strike-through').hide();
        container
            .find('.bfx-list-price')
            .attr({ content: salesprice.value })
            .text(salesprice.formatted);
        container.find('.percent-value').text('');
    } else {
        var isHidden = container.find('.strike-through').css('display');
        if (isHidden === 'none') {
            container.find('.strike-through').css('display', '');
        }

        if (container.find('.bfx-sale-price').length ) {
            container
                .find('.bfx-list-price')
                .attr({ content: listprice.value })
                .text(listprice.formatted);
            container.find('.percent-value').text(percentageoff);
        } else {
            var listPriceText = `<span>
                    <span class="strike-through list">
                        <span class="value bfx-price bfx-original-price bfx-list-price" content="${listprice.value}">${listprice.formatted}</span>
                    </span>
                </span>`;
            var salesPriceText = `<span class="sales"><span class="value bfx-price bfx-sale-price" content="${salesprice.value}">${salesprice.formatted}</span>`;

            if (!hasSalePricebook) {
                container.find('.price-section').html(salesPriceText);
            } else {
                container.find('.price-section').html(listPriceText + salesPriceText);
            }
        }
        container
            .find('.bfx-sale-price')
            .attr({ content: salesprice.value })
            .text(salesprice.formatted);
    }

    if (!hasSalePricebook) {
        container.find('.strike-through').hide();
        container.find('.percent-value').text('');
    }
    // eslint-disable-next-line no-unused-expressions
    salesprice &&
        container
            .find('.bfx-sale-price')
            .attr({ content: salesprice.value })
            .text(salesprice.formatted);
    // eslint-disable-next-line no-unused-expressions
    isNew &&
        container
            .find('.badge-product')
            .show()
            .html('<span>New Arrivals</span>');
    // eslint-disable-next-line no-unused-expressions
    isBestSeller &&
        container
            .find('.badge-product')
            .show()
            .html('<span>Best Seller</span>');

    if (!isNew && !isBestSeller) {
        container.find('.badge-product').hide();

        if (salesBadge) {
            container.find('.badge-product').show();
        }
    }

    //display exclusive badge when not empty and if sales badge is empty
    container.find('.badge-product').removeClass('badge-exclusive');

    if (exclusiveBadge && !salesBadge) {
        container.find('.badge-product').show();
        container.find('.badge-product').addClass('badge-exclusive');

        if (!container.find('.badge-product').length) {
            var badge = '<div class="badge-product"><span>' + exclusiveBadge + '</span></div>';
            container.find('.product-detail').append(badge);
        } else {
            var badge = '<span>' + exclusiveBadge + '</span>';
            container.find('.badge-product').html(badge);
        }

        //hide the 'New to Sale' badge for international users
        var newToSale = resource.NEW_TO_SALE.split(' ').join('');
        if (sitePrefs.IS_INTERNATIONAL && exclusiveBadgeID === newToSale.toLowerCase()) {
            container.find('.badge-product').hide();
        }
    }

    /* re-renders the applicable promotions if the product has active product-level promotions */
    const $targetEl = container.find('.applicable-promotions');
    if (promotions && promotions.length > 0) {
        baseHelper.updateProductPromotions($targetEl, promotions);
    } else {
        $targetEl.empty();
    }

});

$('body').on('click', '.size-value', function () {
    if ($(this).hasClass('selected') === true) {
        $(this).removeClass('selected');
    } else {
        $(this).addClass('selected');
    }
});

$('body').on('click', '.btn-shop-myfit', function (event) {
    event.preventDefault();
    $.spinner().start();
    var url = $(this).attr('href');
    var myfit = {};
    $('.myfit-category').each(function () {
        var $category = $(this);
        var categoryID = $category.attr('id').slice(0, -4);
        var sizes = [];
        if ($category.find('.size-value.selected').length > 0) {
            $category.find('.size-value.selected').each(function () {
                var $size = $(this);
                sizes.push($size.data('displayValue'));
            });
            myfit[categoryID] = sizes;
        }
    });
    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: { fitselection: JSON.stringify(myfit) },
        success: function (data) {
            if (data && data.redirectUrl) {
                window.location.href = data.redirectUrl;
            }
        }
    });
    $.spinner().stop();
});

$('body').on('click', '.refinement-list .refinement-name', function () {
    var $refinement = $(this).parent();
    var isActive = $refinement.hasClass('active');
    var $this = $(this);

    $('.refinement-list .refinement')
        .filter(function () {
            return !$this.closest(this, '.refinements-more-list').length;
        })
        .removeClass('active');
    $refinement.toggleClass('active', !isActive);
});

$('body').on('click', '.product-tile-container .product-tile a', function() {
    const scrollPosition = $('body').data('scroll-position');

    let session = sessionStorage || window.sessionStorage;

    window.history.scrollRestoration = 'manual';
   session.setItem('prevPlpScrollPos', scrollPosition);
});

// initialize the plp image carousel when images are loaded on mobile
function initializeImageCarousels() {
    var isMobile = customUtil.isMobile();

    // plp image carousel configs
    let configs = {
        lazyLoad: 'ondemand',
        arrows: !isMobile,
        dots: true,
        mobileFirst: isMobile
    },

    $plpSearchResultsElement = $('.js-plp-search-results');

    if (!customUtil.isEmpty($plpSearchResultsElement)) {
        let $targetEl = $plpSearchResultsElement.find('.product-tile .image-container .plp-slider');
        slickHelper.setCarousel($targetEl, configs);
        $plpSearchResultsElement.find('.product-tile .image-container').addClass('plp-mobile');
    }
}
// initialize the plp image carousel when images are loaded on mobile
$(document).ready(function () {
    initializeImageCarousels();
});

/** Function that will trigger a initialization of carousels on a page
 * needed when new product tiles are loaded 
 * */
$('body').on('refresh:productTile:carousel', function () {
    initializeImageCarousels();
});
